<template>
  <b-row>
    <b-col sm="12">
      <b-card v-if = "s2 || s3 || s4" :title = "metadata.label">
        <b-button v-if="s2" type="button" variant="primary" @click="c2">Firmar como Jefe de Supervision</b-button>
        <b-button v-if="s3" type="button" variant="primary" @click="c3">Firmar como OT</b-button>
        <b-button v-if="s4" type="button" variant="primary" @click="c4">Firmar como Gerencia</b-button>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FormComponentBase from './FormComponentBase'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'FormComponentInspectionSecurity',
  extends: FormComponentBase,
  /* components: {
    FormComponent: () => import('./FormComponent')
  }, */
  data () {
    return {
      valuex: null,
      s2: false,
      s3: false,
      s4: false,
      session: null
    }
  },
  computed: {
    ...mapState({
      'user': 'user',
      'currmodel': 'currmodel',
      'metadatax': 'metadata'
    })
  },
  mounted () {
    this.check_login()
    if (this.value) {
      this.valuex = this.value
    }
  },
  watch: {
    value: function (val) {
      this.$set(this, 'valuex', val)
      this.$emit('valuechange', val)
    },
    user: function (to) {
      this.check_login()
    }/* ,
    session: function (to) {
      this.check_session()
    } */
  },
  methods: {
    ...mapActions([
      'get_session'
    ]),
    check_login () {
      var obj = this
      obj.check_session()
      /* this.get_session().then(function (session) {
        // obj.check_session(session)
        obj.session = session
        obj.check_session()
      }).catch(function (err) {
        console.log(err)
        // obj.check_session(null)
        obj.session = null
        obj.check_session()
      }) */
    },
    check_session () {
      // console.log(session)
      var obj = this
      if (obj.user) {
        if (obj.user.roles.indexOf('_admin') !== -1 || obj.user.roles.indexOf('inspection_4') !== -1 ||
          obj.user.roles.indexOf('inspection_4_57') !== -1 || obj.user.roles.indexOf('inspection_4_88') !== -1) {
          obj.s2 = false
          obj.s3 = false
          obj.s4 = true
        } else if ((obj.user.roles.indexOf('inspection_3') !== -1) ||
          (obj.user.roles.indexOf('inspection_3_57') !== -1) || (obj.user.roles.indexOf('inspection_3_88') !== -1)) {
          obj.s2 = false
          obj.s3 = true
          obj.s4 = false
        } else if (obj.user.roles.indexOf('inspection_2') !== -1 ||
          obj.user.roles.indexOf('inspection_2_57') !== -1 || obj.user.roles.indexOf('inspection_2_88') !== -1) {
          if (obj.currmodel.supervisor_2 || obj.currmodel.supervisor_3 || obj.currmodel.supervisor_4) {
            obj.s2 = false
            obj.s3 = false
            obj.s4 = false
          } else {
            obj.s2 = true
            obj.s3 = false
            obj.s4 = false
          }
        } else {
          obj.s2 = false
          obj.s3 = false
          obj.s4 = false
        }
      } else {
        obj.s2 = false
        obj.s3 = false
      }
    },
    c2 () {
      var obj = this
      if (obj.user) {
        obj.$emit('updatex', {
          action: 'set',
          target: 'supervisor_2',
          id: null,
          object: obj.user.name
        })
        obj.check_login()
      }
    },
    c3 () {
      var obj = this
      if (obj.user) {
        obj.$emit('updatex', {
          action: 'set',
          target: 'supervisor_3',
          id: null,
          object: obj.user.name
        })
        obj.check_login()
      }
    },
    c4 () {
      var obj = this
      if (obj.user) {
        obj.$emit('updatex', {
          action: 'set',
          target: 'supervisor_4',
          id: null,
          object: obj.user.name
        })
        obj.check_login()
      }
    }
  }
}
</script>
